import {Fragment, useState} from 'react'
import {useParams, useLocation, useNavigate} from 'react-router-dom'
import {useForm} from 'react-hook-form'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

import Details from '../../shared/Details'
import Modal from '../../shared/Modal'
import CopyToClipboard from '../../shared/CopyToClipboard'

import {connect} from '../../../state/hooks/tools'
import {findRecordByAttribute} from '../../../lib/data'
import {deleteResource, updateResource, readEndpoint} from '../../../lib/asyncMethods'
import {INVITES} from '../../../state/actionTypes'

const HeaderActions = props => (
 <Button disabled={props.loading} onClick={props.sendInvitation} sx={{bgcolor: 'Background', height: '41px'}}>
    <Typography variant='span'>Send Invitation</Typography>
  </Button>
)

const EditActions = props => (
  <Fragment>
    <Button onClick={props.goBack} sx={{bgcolor: 'Background'}}>
      <ArrowBackIcon />
      <Typography variant='span'>Back</Typography>
    </Button>
    <Stack className='button-group' direction='row'>
      {
        props.edit ? (
          <Button disabled={props.loading} type='submit' form='form' sx={{bgcolor: 'Background'}}>
            <Typography variant='span'>Save</Typography>
          </Button>
        ) : (
          <Button onClick={props.editDetails} sx={{bgcolor: 'Background'}}>
            <EditIcon fontSize='small' />
            <Typography variant='span'>Edit</Typography>
          </Button>
        )
      }
      {
        (!props.edit && props.deletable) && (
          <Button disabled={props.loading} onClick={props.destroy} className='delete' sx={{bgcolor: '#910708', marginLeft: '8px', color: '#F7F7F7'}}>
            <DeleteIcon fontSize='small' />
            <Typography variant='span'>Delete</Typography>
          </Button>
        )
      }
    </Stack>
  </Fragment>
)

const Invite = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const [showModal, setShowModal] = useState(false)
  const [url, setUrl] = useState('')
  const data = findRecordByAttribute({records: props.invites, attribute: 'id', id: params.id})
  const methods = useForm({defaultValues: data})

  const goBack = () => {
    navigate(-1)
  }

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const updateRecord = data => {
    props.updateResource({endpoint: `invites/${params.id}/edit`, attributes: data}).then(response => {
      if (response.success)
        goBack()
    })
  }

  const sendInvitation = () => {
    props.readEndpoint(`invites/${data.id}/invitation`).then(response => {
      if (response.success) {
        setUrl(response.data)
        toggleModal()
      }
    })
  }

  const destroy = () => {
    props.deleteResource(`invites/${params.id}`).then(response => {
      if (response.success)
        navigate('/admin/invites')
    })
  }

  return (
    <Fragment>
      <Details
        data={data}
        deletable
        destroy={destroy}
        formMethods={methods}
        handleSubmit={updateRecord}
        loading={props.loading}
        edit={location.pathname.includes('edit')}
        sendInvitation={sendInvitation}
        headerActions={HeaderActions}
        editActions={EditActions}
      />
      <Modal
        disableBackdrop
        open={showModal}
        handleClose={toggleModal}
        disabled={props.loading}
        subHeading='Please copy the URL below and share with the appropriate invitee.'
        buttonText='Done'
        title='Sent Invitation'>
          <CopyToClipboard text={url} />
      </Modal>
    </Fragment>
  )
}

const mapStateToProps = ({invites}) => ({...invites})

const actionCreators = ({invites}) => ({
  deleteResource: deleteResource(invites, INVITES),
  readEndpoint: readEndpoint(invites, INVITES),
  updateResource: updateResource(invites, INVITES)
})

export default connect(mapStateToProps, actionCreators)(Invite)
